// extracted by mini-css-extract-plugin
module.exports = {"container":"IllicitActivity_title_container__1VSfV","title":"IllicitActivity_title_title__Xk8GV","subTitle":"IllicitActivity_title_subTitle__2xwNC"};